
// production
export const url = 'https://crmsapi.leadsplugin.com';

// development
// export const url = 'https://photography-crm-api.bharatmakers.com';

// local 
// export const url = 'http://localhost/api/photographycrm-api';
